import React from 'react';
import PropTypes from 'prop-types';
import { Input } from 'reactstrap';
import { useIntl } from 'react-intl';

import { strikeThrough } from '../../../helpers';
import { formatCurrency } from '../../../helpers/App';

const AdminPaymentPricingSelect = ({
  prices,
  interval,
  selectedPriceIndex,
  currentPriceId,
  handleChange,
}) => {
  const intl = useIntl();

  const intervalPrices = prices.filter(p => (p.interval === interval));

  if (intervalPrices.length === 0) {
    return (
      <h5 className="center">
        {intl.formatMessage({ defaultMessage: 'Monthly payments are not available for this plan' })}
      </h5>
    );
  }

  return (
    <Input
      className="custom-select"
      type="select"
      onChange={handleChange}
      value={intervalPrices[selectedPriceIndex]?.id}
      defaultChecked={intervalPrices[selectedPriceIndex]?.id}
    >
      {intervalPrices.map(price => (
        <option
          key={price.id}
          value={price.id}
          disabled={!price.enabled && price.id !== currentPriceId}
        >
          {price.promo_storage_size ? (
            `${strikeThrough(price.storage_size)} ${price.promo_storage_size}`
          ) : (
            price.storage_size
          )}
          {' '}
          {intl.formatMessage({
            defaultMessage: '({price} / month)',
          }, {
            price: `$${formatCurrency(interval === 'year' ? price.price / 12 : price.price)}`,
          })}
          {price.id === currentPriceId && (
            ' - your plan'
          )}
        </option>
      ))}
    </Input>
  );
};

AdminPaymentPricingSelect.propTypes = {
  prices: PropTypes.array.isRequired,
  interval: PropTypes.string.isRequired,
  selectedPriceIndex: PropTypes.number.isRequired,
  currentPriceId: PropTypes.string,
  handleChange: PropTypes.func.isRequired,
};

AdminPaymentPricingSelect.defaultProps = {
  currentPriceId: null,
};

export default AdminPaymentPricingSelect;
